import type {RawSolutionPartner, SolutionPartner} from '@/types/solution-partner';

export const mapRawToSolutionPartner = (raw : RawSolutionPartner) : SolutionPartner => raw;
